import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CButton,
} from "@coreui/react";
import { FaEye, FaTimes } from "react-icons/fa";
import "../../Table/Table.scss";

const DefectsTab = ({ object }) => {
  const [defectData, setDefectData] = useState([]);
  const [error, setError] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      setError("Токен авторизации не найден. Пожалуйста, войдите в систему.");
      return;
    }

    if (object?.LDoc) {
      axios
        .get(`/api/ldoc/${object?.LDoc}/combined-defects/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data && Array.isArray(response.data.data)) {
            setDefectData(response.data.data);
          } else {
            setError("Полученные данные не являются массивом.");
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              setError("Ошибка авторизации. Пожалуйста, войдите снова.");
            } else {
              setError(`Ошибка сервера: ${error.response.status}`);
            }
          } else if (error.request) {
            setError("Сервер не отвечает. Проверьте подключение к интернету.");
          } else {
            setError(`Ошибка: ${error.message}`);
          }
        });
    }
  }, [object?.LDoc, token]);

  const openModal = (details) => {
    setModalData(details);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  const openPhotoModal = (src) => {
    setCurrentPhoto(src);
    setPhotoModalOpen(true);
  };

  const closePhotoModal = () => {
    setCurrentPhoto(null);
    setPhotoModalOpen(false);
  };

  return (
    <div>
      {error && <p style={{ color: "red" }}>{error}</p>}

      {defectData.length === 0 && !error && (
        <p>Информация о дефектах не найдена.</p>
      )}

      {defectData.length > 0 &&
        Object.values(
          defectData.reduce((acc, item) => {
            if (!acc[item["Наименование ведомомсти"]]) {
              acc[item["Наименование ведомомсти"]] = [];
            }
            acc[item["Наименование ведомомсти"]].push(item);
            return acc;
          }, {})
        ).map((group, idx) => (
          <div className="about-objects__wrapper" key={idx}>
            <h4 className="about-objects__title">
              {group[0]["Наименование ведомомсти"]}
            </h4>
            <div className="about-objects__table-wrapper">
              <CTable className="about-objects__table">
                <CTableHead className="about-objects__head about-objects__head--png">
                  <CTableRow>
                    <CTableHeaderCell>Дефект</CTableHeaderCell>
                    <CTableHeaderCell>Описание</CTableHeaderCell>
                    <CTableHeaderCell>Место</CTableHeaderCell>
                    <CTableHeaderCell>Метод устранения</CTableHeaderCell>
                    <CTableHeaderCell>Норматив</CTableHeaderCell>
                    <CTableHeaderCell>Причины</CTableHeaderCell>
                    <CTableHeaderCell>Фотографии</CTableHeaderCell>
                    <CTableHeaderCell>Детали</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody className="about-objects__body">
                  {group.map((item, i) => (
                    <CTableRow key={i}>
                      <CTableDataCell>
                        {item["Название дефекта и повреждения оттяжки"] || "-"}
                      </CTableDataCell>
                      <CTableDataCell>
                        {item["Описание дефекта"] || "-"}
                      </CTableDataCell>
                      <CTableDataCell>
                        {item["Местоположение"] || "-"}
                      </CTableDataCell>
                      <CTableDataCell>
                        {item["Метод устранения"] || "-"}
                      </CTableDataCell>
                      <CTableDataCell>
                        {item["Нормативная ссылка"] || "-"}
                      </CTableDataCell>
                      <CTableDataCell>
                        {item["Возможные причины"] || "-"}
                      </CTableDataCell>
                      <CTableDataCell>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          {item["фото1"] && (
                            <img
                              src={`${item["фото1"].replace(
                                "pathtofiles/",
                                `pathtofiles/${token}/`
                              )}`}
                              alt="Фото 1"
                              style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                margin: "5px 0",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                openPhotoModal(
                                  item["фото1"].replace(
                                    "pathtofiles/",
                                    `pathtofiles/${token}/`
                                  )
                                )
                              }
                            />
                          )}
                          {item["фото2"] && (
                            <img
                              src={`${item["фото2"].replace(
                                "pathtofiles/",
                                `pathtofiles/${token}/`
                              )}`}
                              alt="Фото 2"
                              style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                margin: "5px 0",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                openPhotoModal(
                                  item["фото2"].replace(
                                    "pathtofiles/",
                                    `pathtofiles/${token}/`
                                  )
                                )
                              }
                            />
                          )}
                        </div>
                      </CTableDataCell>
                      <CTableDataCell>
                        {item.defect_details &&
                          item.defect_details.length > 0 && (
                            <button
                              onClick={() => openModal(item.defect_details)}
                              style={{
                                padding: "5px 10px",
                                background: "#0d6efd",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            >
                              <FaEye />
                            </button>
                          )}
                      </CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </div>
          </div>
        ))}

      {/* Модальное окно для деталей */}
      <CModal
        visible={isModalOpen}
        onClose={closeModal}
        className="defect-details-modal"
      >
        <CModalHeader onClose={closeModal}>
          <CModalTitle>Детали дефекта</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {modalData && (
            <CTable striped bordered hover>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell rowSpan={2}>Отметка, м</CTableHeaderCell>
                  <CTableHeaderCell colSpan={4}>
                    Номер пояса/грани
                    <br />
                    Количество дефектных соединений, шт.
                  </CTableHeaderCell>
                </CTableRow>
                <CTableRow>
                  {[1, 2, 3, 4].map((col) => (
                    <CTableHeaderCell key={col}>{col}</CTableHeaderCell>
                  ))}
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {[...new Set(modalData.map((row) => row.firstCellValue))].map(
                  (firstValue, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{firstValue}</CTableDataCell>
                      {[1, 2, 3, 4].map((col) => {
                        const cell = modalData.find(
                          (item) =>
                            item.firstCellValue === firstValue &&
                            Number(item.collCell) === col
                        );
                        return (
                          <CTableDataCell key={col}>
                            {cell && cell.cellValue ? cell.cellValue : ""}
                          </CTableDataCell>
                        );
                      })}
                    </CTableRow>
                  )
                )}
              </CTableBody>
            </CTable>
          )}
        </CModalBody>
      </CModal>

      {/* Модальное окно для фото */}
      <CModal
        visible={photoModalOpen}
        onClose={closePhotoModal}
        size="lg"
        className="photo-modal"
      >
        <CModalHeader onClose={closePhotoModal}>
          <CModalTitle>Просмотр фотографии</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ textAlign: "center" }}>
          {currentPhoto && (
            <img
              src={currentPhoto}
              alt="Увеличенное фото"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
            />
          )}
        </CModalBody>
      </CModal>
    </div>
  );
};

export default DefectsTab;
